<script setup lang="ts">
import { TransitionRoot } from '@headlessui/vue'
import { MinusIcon, PlusIcon } from '@heroicons/vue/24/solid'
import { type Component, ref } from 'vue'

const props = withDefaults(
  defineProps<{
    isCollapsible?: boolean
    title: string
  }>(),
  {
    isCollapsible: true,
  },
)

defineSlots<{
  default(): Component
}>()

const isOpen = ref(true)

const toggleOpen = (): void => {
  if (!props.isCollapsible) return
  isOpen.value = !isOpen.value
}
</script>

<template>
  <section
    class="w-full border-b border-dotted border-b-black-200 px-8 py-5 last-of-type:border-none"
  >
    <div class="flex items-center justify-between">
      <h2 class="font-medium">{{ title }}</h2>
      <button v-if="props.isCollapsible" type="button" @click="toggleOpen">
        <PlusIcon v-if="!isOpen" class="aspect-square h-5" />
        <MinusIcon v-else class="aspect-square h-5" />
      </button>
    </div>
    <TransitionRoot
      as="div"
      class="grid transition-[grid-template-rows] duration-300"
      enter="transition-[grid-template-rows] duration-300"
      enter-from="grid-rows-[0fr]"
      enter-to="grid-rows-[1fr]"
      leave="transition-[grid-template-rows] duration-300"
      leave-from="grid-rows-[1fr]"
      leave-to="grid-rows-[0fr]"
      :show="isOpen"
      :unmount="false"
    >
      <div
        class="overflow-hidden *:pt-5"
        :class="!isOpen ? 'overflow-hidden' : 'showOverflow_class'"
      >
        <slot></slot>
      </div>
    </TransitionRoot>
  </section>
</template>

<style scoped>
.showOverflow_class {
  animation: showOverflow 0.1s forwards;
  animation-delay: 300ms;
}

@keyframes showOverflow {
  0% {
    overflow: hidden;
  }
  100% {
    overflow: visible;
  }
}
</style>
